module.exports = __webpack_public_path__ + "img/14.e527fe1f.jpg";